module.exports = __webpack_public_path__ + "img/atat-icon.5ee6de7f.svg";